<template>
  <div>
    <div
      id="setting-container">
      <b-row>
        <b-col cols="12">
          <jBoardAssignee
            ref="refBoardAssignee"
            :board-id="board.id"
            :form-id="board ? board.input_value : 0"/>

        </b-col>

      </b-row>

    </div>
  </div>
</template>

<script>
import jBoardAssignee from '@/views/board/assignee/jBoardAssignee';
import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardMemberTab',
  components: {
    jBoardAssignee,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchQuery: '',
      onUpdate: false,

    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board', 'boards_updated', 'form_detail']),
  },
  watch: {

  },
  created() {

  },

  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoards', 'updateForm', 'detailForm', 'updateComponent', 'actionUpdateVisibilityPrivilege', 'actionUpdateEmailReminder']),

  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/board/tabs/jBoardMemberTab.vue